<template>
  <div class="app-wrapper">
    <Sidebar v-if="isCommand"/>
    <div v-else class="sidebar-adapter"></div>
    <BookMeeting v-if="isCommand" />
    <div class="main-container">
      <div v-if="isCommand" >
        <div class="main-header-empty"></div>
        <div class="main-header">
          <header-bar @openRegist="openRegist"></header-bar>
        </div>
      </div>
      <keep-alive :include="includeList">
        <router-view class="computed-content-height"  :key="key" />
      </keep-alive>
    </div>
    <Chatbox />
    <!-- <Support v-if="isCommand" /> -->
    <common-Diamond-Prompt v-if="isCommand" :dialogVisible="isShow" @cancel="isShow = false" />
    <common-dialog
      v-if="isCommand"
      :dialogVisible="diamondWelcomeDialogVisible"
      :isCancel="false"
      :img="successIcon"
      title="Welcome to COMMAND"
      content="You are now logged in to the Owner Operator version with access to our Map and Drivers module. Please upgrade your account to enjoy all premium features."
      confirmContent="Got it"
      typeColor="#4066d4"
      @confirm="handleConfirm"
    >
    </common-dialog>
    <ContactsAddDiaLog
      v-if="fleetShowCustomerDialog"
      fromTypeLoadAddCustomerName="load"
      headerTitle="Add New Customers"
      fromType="add"
      @addNewCustomersClose="fleetLoadaddNewCustomersClose"
      @handleAddSubmit="handleAddSubmit"
    ></ContactsAddDiaLog>
    <contactsAddDiaLog
      v-if="fleetShowLocationDialog"
      fromTypeLoadAddCustomerName="load"
      headerTitle="Add New Location"
      fromType="add"
      specialTag="loadBusinessName"
      tabFlag="Location"
      @addNewCustomersClose="addNewBusinessClose"
      @handleAddSubmit="handleAddSubmitLocation"
    ></contactsAddDiaLog>
    <!-- <regist-dialog  v-if="showRegist" @close="close"></regist-dialog> -->
     <regist-dialog  v-if="showRegist" @close="close" :redirect="redirect" source="Top Right CTA"></regist-dialog>
    <AssignDirverDiaLog
      @success="Assingsuccess" v-if="fleetShowAssignDialog" @closeAssignDiaLog="closeAssignDiaLog">
    </AssignDirverDiaLog>
    <fullVersionTopremium 
      :title="isShowLoadUpgrade ? 'Assign More Loads ?' : 'Upload More Documents?'"
      :titleTips="isShowLoadUpgrade ? 'Free subscriptions are limited to <span style=color:#000>10</span> loads. Upgrade subscription to get more.' : `Free subscriptions are limited to <span style=color:#000>30</span> file uploads. Upgrade subscription to file more.`"
      v-if="showpremium" 
      @close="closeTopremium" >
    </fullVersionTopremium>
    <Schedule></Schedule>
    <Eld  v-if="eld_target && !isCommand" :target="eld_target" :dsp_permission="dsp_permission" :getHosApi="getHosApi" :vin.sync="vin"></Eld>
    <CalcFuelPlan :visible="showCalcFuelPopup" :success="calcFuelPopupSuccess" :close="calcFuelPopupClose"/>
  </div>
</template>
<script>
import Chatbox from '@/chatbox';
import Sidebar from './components/sidebar.vue'
import { mapActions, mapState } from "vuex";
import {tap} from 'rxjs';
import Eld from '@/views/dispatchs/dispatch/detail/components/tracking/components/hosLog.vue'
import CalcFuelPlan from '@/views/guide-v2/fuel-plan/map-popup';
import HeaderBar from '@/components-v2/common-header/header-bar.vue';
import ContactsAddDiaLog from "@/views/contacts/add.vue";
import successIcon from "@/assets/img/eldv2/icon-popconfirm-check.svg";
import {OnBoarding$, systemInfo} from "@/shared-services";
import { getService$ } from '@/shared-services.js'
import RegistDialog from '@/views/scan-document/components/regist-dialog.vue'
import { setStorage, TokenKey } from "@/utils/storage";
// import Support from '@/views/support'
import {dispatchCommandLike$ } from "@/shared-services";
import {filterEventOb$} from "@/services/push";
import {ELD_RECONNECTED, SYSTEM_MESSAGE_INSURANCE} from "@/services/push/events";
import AssignDirverDiaLog from '@/views/dispatchs/dispatch/loads/load-list-components/assgin.vue'
import fullVersionTopremium from '@/views/login-v2/full-version-to-premium-dialog/index.vue'
import Schedule from '@/views/schedule/index'
import BookMeeting from '@/views/book-meeting/index.vue'
import Vue from 'vue'
// import { getTPAuthToken } from "@/api/user";
// import {mfRegister} from "@/tl-mf-config";

export default {
  components: {Sidebar, CalcFuelPlan, HeaderBar, RegistDialog, ContactsAddDiaLog, AssignDirverDiaLog, fullVersionTopremium, Eld, Chatbox, Schedule, BookMeeting },
  data() {
    return {
      redirect: `${location.pathname}${location.search}`,
      eld_target: null,
      dsp_permission: false,
      vin: '',
      showCalcFuelPopup: false,
      blacklist: [
        /^\/dispatch(\/.*)?$/,
        /^\/contacts(\/.*)?$/,
        /^\/document(\/.*)?$/,
        /^\/accounting(\/.*)?$/,
        /^\/assets(\/.*)?$/,
        /^\/message(\/.*)?$/,
        /^\/bulletin(\/.*)?$/,
        /^\/setting\/appearance(\/.*)?$/,
        /^\/setting\/eld(\/.*)?$/,
      ],
      isShow: false,
      successIcon: successIcon,
      includeList: [],
      isCommand: systemInfo.isCommand,
      fleetShowCustomerDialog: false,
      fleetShowLocationDialog: false,
      fleetShowAssignDialog: false,
      showRegist: false,
      isShowDialog: true,
      currentAssingPage: null,
      showpremium: false,
      loactionCurrentType: null,
      isShowLoadUpgrade: true,
      getHosApi: false
    }
  },
  computed: {
    ...mapState('im', ['dragChatbox']),
    ...mapState('user', ['topHeight', 'diamondWelcomeDialogVisible', 'demoType', 'freemiumStep', 'userId', 'scheduleWelcome']),
    ...mapState({
      usersAuthorities: (state) => state.user.usersAuthorities,
      userInfo: (state) => state.user,
    }),
    key() {
      if (['dispatchDetail', 'driverDetails'].includes(this.$route.name)) {
        return this.$route.fullPath
      }
      if (this.isCommand) {
        return this.$route.path;
      } else {
        if(/^\/setting\/eld(\/.*)?$/.test(this.$route.path)) {
          return '/setting/eld'
        } else {
          return this.$route.path;
        }
      }
    },
    TPlandingpageDialogShow(){
      const showDemoType = ['trial', 'freemium']
      return showDemoType.includes(this.userInfo.demoType) && this.userInfo.role === 'admin' &&
      (!this.judgeIsValue(this.userInfo.dot) || !this.judgeIsValue(this.userInfo.companyName) || !this.judgeIsValue(this.userInfo.phone) || !this.judgeIsValue(this.userInfo.firstName) || !this.judgeIsValue(this.userInfo.lastName))
    }
  },
  beforeDestroy() {
    this.sub$.forEach(x => x.unsubscribe())
    this.$event && this.$event.unsubscribe()
  },
  created() {
    this.sub$ = [];
    if (systemInfo.isCommand) {
      OnBoarding$.subscribe((service) => {
        this.onBoardingService = service;
        this.sub$.push(service.fuelPlanEvent$().subscribe(x => {
          if(x.event === 'showPopup') {
            this.showCalcFuelPopup = true;
          }
        }))
      })
      filterEventOb$(SYSTEM_MESSAGE_INSURANCE).subscribe((res) => {
        const data = JSON.parse(res.params.data.data.info)
        const content = `${data.driverName} has filled an insurance claim for ${data.vehicleNo}`
        Vue.prototype.$tpNotification({
          title: 'System Message',
          avatar: "https://forum-images-prod.s3.us-west-2.amazonaws.com/tp/support/0/15dc6ffb-c9f9-495f-bdad-32a55bf08a80/d41d8cd98f00b204e9800998ecf8427e.png",
          showBtn: false,
          showIcon: true,
          showClose: true,
          message: content
        })
      })
      dispatchCommandLike$.subscribe(x => {
        if (!this.TPlandingpageDialogShow && this.scheduleWelcome) {
          x.changeScheduleDialog(true)
        }
      })
      this.$event = filterEventOb$(ELD_RECONNECTED).subscribe((data) => {
        let name = ''
        try {
          const params = data?.params?.data?.data?.info
          const eldInfo = JSON.parse(params || '{}')
          name = eldInfo.data[0].source.join()
        } catch (error) {
          console.log(name)
        }
        if (name) {
          dispatchCommandLike$.subscribe(x => x.changePopupDialog({
            isShow: true,
            name: name
          }))
        }
      })
    }
    if (systemInfo.isCommand) {
      // if (['TPHomepage', 'Commandhomepage', 'TPbulkdiscountCommandhomepage'].includes(this.$route.query.UTM_source)) {
      //   setStorage('Official website', 'commandRegistSource')
      // }else if(this.$route.query.UTM_source) {
      // }
      console.log(109, this.$route.query.UTM_source, this.$route.query.UTM_source)

      setStorage(this.$route.query.UTM_source, 'commandRegistSource')
    }
    if (systemInfo.isCommand && this.userId) {
      dispatchCommandLike$.subscribe(x => x.initCommandLayout())
    }
    this.$root.$on('openRegist', () => this.showRegist = true)
    if (systemInfo.isCommand && !this.userId) {
      let utm = this.$route.query.UTM_source
      let source = this.$route.query.UTM_source
      if (utm == 'Commandhomepage') {
        source = 'COMMAND'
      }  else if (utm == 'TPHomepage') {
        source = 'Trucker Path'
      } else if (!utm) {
        source = 'Login page'
      }
      this.$buriedPoints(18.14, {
        Source: source
      })
    }
    if (systemInfo.isCommand && this.demoType == 'freemium') {
      this.getFreeNum()
    }
    if(Number(localStorage.getItem('time'))+3000 > Date.now()) {
      if (typeof this.sessionsUnread !== 'number' || this.sessionsUnread === 0) return;
      this.$tpNotification({
        showBtn: false,
        title: "Message",
        message: `You have ${this.sessionsUnread} unread messages`,
        showIcon: false,
        showClose: true,
        onClick: () => {
          this.setPutChat(false);
        },
      })
    }
  },
  watch: {
    "$route": {
      handler(newVal) {
        this.isShow = this.$checkPermission(['diamond']) && this.matchBlacklist(newVal.path)
        if (newVal.meta && newVal.meta.keepAlive && this.includeList.indexOf(newVal.meta.keepName) === -1) {
          this.includeList.push(newVal.meta.keepName)
        }
      },
      immediate: true
    },
    currentAssingPage: {
      handler(value) {
        console.log(value,'176result')
      }
    },
    immediate: true,
    deep: true
  },
  methods: {
    ...mapActions("im", ["showChatbox", "setPutChat"]),
    ...mapActions('user', ['getFreeNum']),
    ...mapActions({
      showAssgin: "dispatch/showAssgin",
      updateDiamondWelcomeDialogVisibleAsync: 'user/updateDiamondWelcomeDialogVisible'
    }),
    calcFuelPopupSuccess() {
      this.showCalcFuelPopup = false;
    },
    calcFuelPopupClose() {
      this.onBoardingService.onLastSkip();
      this.showCalcFuelPopup = false;
    },
    judgeIsValue(data) {
      return data !== null && data !== undefined && data !==  ''
    },
    closeTopremium() {
      this.showpremium = false
    },
    openRegist() {
      this.showRegist = true
    },
    close() {
      console.log(123123)
      this.showRegist = false
    },
    matchBlacklist(path) {
      const list = this.blacklist.filter(i => !!i);
      return list.some(item => item.test(path))
    },
    handleConfirm() {
      this.updateDiamondWelcomeDialogVisibleAsync(false)
      if (this.$route.path !== '/dashboard') {
        this.$router.push('/dashboard')
      }
    },
    fleetLoadaddNewCustomersClose() {
       getService$('CommandTools').subscribe(x => {
        x.$fleetShowDialog.next({success: 200})
       })
      this.fleetShowCustomerDialog = false
    },
    handleAddSubmit(data) {
      this.fleetShowCustomerDialog = false
      this.fleetShowLocationDialog = false
      getService$('CommandTools').subscribe(x => {
        x.$fleetShowDialog.next({id: data, key: 'customerSuccess'})
      })
    },
    handleAddSubmitLocation(data) {
      this.fleetShowCustomerDialog = false
      this.fleetShowLocationDialog = false
      getService$('CommandTools').subscribe(x => {
        x.$fleetShowDialog.next({id: data, key: 'locationSuccess', locationType: this.loactionCurrentType})
      })
    },
    Assingsuccess() {
      this.getHosApi = true
      setTimeout(() => {
        this.getHosApi = false
      })
      let that = this
      getService$('CommandTools').subscribe(x => {
        console.log({id: '', key: 'assignSuccess', type: that.currentAssingPage}, '221result', that.currentAssingPage);
        x.$fleetShowDialog.next({id: '', key: 'assignSuccess', type: that.currentAssingPage})
      })
    },
    addNewBusinessClose() {
      this.fleetShowLocationDialog = false
    },
    handleBusinessAddSubmit() {
      this.fleetShowLocationDialog = false
    },
    componentsFn(value, target) {
      switch (value) {
        case "load-tracking-eld": 
          this.eld_target = target.el
          this.dsp_permission = target.permission
          break;
        default:
          break;
      }
    },
    $watchDspLoadData() {
       getService$('CommandTools').subscribe(x => {
        x.$fleetShowDialog.subscribe({
          next: (x) => {
            this.loactionCurrentType = x.type
            if(x['showCustomer']) this.fleetShowCustomerDialog = true;
            if(x['showLocation']) this.fleetShowLocationDialog = true;
            if(x['FreemiumDoc']) {
                this.showpremium = true
                this.isShowLoadUpgrade = x['isLoad']
            }
            if(x['showAssign']) {
              this.fleetShowAssignDialog = true;
              this.currentAssingPage = x['pageType']
              console.log(x['data'],'287result');
              this.showAssgin({
                assginData: true,
                value: {
                  loadInfo: x['data'],
                  driverRoute: [],
                  name: x['type'] === 'reAssign' ? 'reAssign' : "Assign", 
                  id: x['data'].id,
                },
                name: "Assign",
              });
            } 
          }
        })
        getService$('CommandTools').subscribe(x => {
          x.$subscribeComponents.pipe(
            tap(x => console.log(x,'xxxx')),
          ).subscribe(x => {
            console.log(x,'90result');
            this.componentsFn(x.name, x.target)
          })
        })
      })
    },
    closeAssignDiaLog() {
      this.fleetShowAssignDialog = false;
    }
  },
  beforeRouteLeave(to, from, next) {
    if (this.dragChatbox.show) {
      this.showChatbox({
        show: true,
      })
    } else {
      this.showChatbox({
        show: false,
      })
    }
    
    next();
  },
  mounted() {
    console.log('1231husidaisd')
    this.$watchDspLoadData()
    if (systemInfo.isCommand) {
      window.addEventListener('storage', (res)=> {
        if (res.key == TokenKey) {
          window.location.reload()
        }
      })
    }
    
  }
};
</script>
<style lang="scss" scoped>
.app-wrapper {
  width: 100%;
  height: 100%;
  .sidebar-adapter {
    width: 72px;
    height: 1px;
  }
  .main-container {
    min-width: 1368px;
    height: 100%;
    overflow-y: auto;
    .prompt {
      // position: fixed;
      // top: 0;
      // left: 72px;
      width: 100%;
      min-width: 1368px;
      height: 30px;
      padding: 0 15px;
      display: flex;
      align-items: center;
      background-color: #e6c6c6;
      font-size: 12px;
      font-family: OpenSans-Bold, sans-serif;
      color: #b11111;
      z-index: 99999999;
    }
  }

  .main-header-empty{
    height: 100%;
  }
  .main-header{
    position: fixed;
    z-index: 2000;
    top: 0;
    left: 72px;
    width: calc(100% - 72px);
  }
}
</style>
